import { render } from "./editFacilities.vue?vue&type=template&id=08b0b298&scoped=true"
import script from "./editFacilities.vue?vue&type=script&lang=js"
export * from "./editFacilities.vue?vue&type=script&lang=js"

import "./editFacilities.vue?vue&type=style&index=0&id=08b0b298&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b0b298"]])

export default __exports__